import { CLEAR_SITES_FROM_SRM } from "constants/ActionTypes";

export function clearSitesFromSRM() {
  return {
    type: CLEAR_SITES_FROM_SRM,
    value: { customerSitesFromSRM: { sites: [] } }
  };
}
